import { Common } from './common.model';
import {
    EmbeddedCompany,
    EmbeddedUser,
    toUserEmbedded,
    toCompanyEmbedded,
    Embedded
} from './embed.model';

export type embed = keyof EmbedProperties;

interface EmbedProperties {
    $createdBy: EmbeddedUser;
    $updatedBy: EmbeddedUser;
    billingClient: EmbeddedCompany;
    contractClient: EmbeddedCompany;
    paymentClient: EmbeddedCompany;
    operationalClient: EmbeddedCompany;
}

export enum BusinessProjectStatus {
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED'
}

export enum BusinessProjectStatusTranslation {
    ACTIVE = 'Actif',
    TERMINATED = 'Résilié'
}

export type EmbedBusinessProject = Omit<BusinessProject, 'billingClient' | 'contractClient' | 'paymentClient' | 'operationalClient'>
& EmbedProperties;

export class BusinessProject extends Common {
    public name: string;
    public businessUnitName: string;
    public crmId: string;
    public crmUrl: string;
    public documents: Array<{ name: string; url: string }>;

    public billingClient: string;
    public contractClient: string;
    public paymentClient: string;
    public operationalClient: string;
    public terminationDate: Date;
    public status: BusinessProjectStatus;

    constructor(data: Partial<BusinessProject>) {
        super(data);
        this.name = data.name || '';
        this.businessUnitName = data.businessUnitName || '';
        this.crmId = data.crmId || '';
        this.crmUrl = data.crmUrl || '';
        this.documents = data.documents || [];
        this.billingClient = data.billingClient || '';
        this.contractClient = data.contractClient || '';
        this.paymentClient = data.paymentClient || '';
        this.operationalClient = data.operationalClient || '';
        this.terminationDate = data.terminationDate ? new Date(data.terminationDate) : null;
        this.status = data.status ?? BusinessProjectStatus.ACTIVE;
    }

    public static toBusinessProjectEmbedded(data: BusinessProject, embedded?: Embedded): EmbedBusinessProject {
        return {
            ...data,
            $createdBy: toUserEmbedded(data, 'createdBy', embedded),
            $updatedBy: toUserEmbedded(data, 'updatedBy', embedded),
            billingClient: toCompanyEmbedded(data, 'billingClient', embedded),
            contractClient: toCompanyEmbedded(data, 'contractClient', embedded),
            paymentClient: toCompanyEmbedded(data, 'paymentClient', embedded),
            operationalClient: toCompanyEmbedded(data, 'operationalClient', embedded),
        };
    }
}
